import actions, {
    EXPORT_DIALOG_CLOSE,
    EXPORT_GENERATE_ERROR,
    EXPORT_GENERATE_STARTED,
    EXPORT_GENERATE_SUCCESS
} from "./exportEntriesActions";

const initialState = {
    page: 0,
    rowsPerPage: 5,
    exports: [],
    exportData: null,
    dialogOpen: false,
    loading: false,
    status: null
}


const updateExports = (state, action) => {
    const newState = {...state};
    newState.exports = action.exports;
    newState.loading = false;
    return newState;
}

const updateExportPagePagination = (currentState, action) => {
    const newState = {...currentState};
    if (typeof(action.page) === 'number') {
        newState.page = action.page;
    }
    if (typeof(action.rowsPerPage) === 'number') {
        newState.rowsPerPage = action.rowsPerPage;
    }

    return newState;
}

function exportEntriesReducer(state = initialState, action) {
    switch (action.type) {
        case actions.EXPORT_LOAD_LIST_STARTED:
            return {
                ...state,
                loading: true
            };
        case actions.EXPORT_LOAD_LIST_ERROR:
            // TODO figure out something cool to do here like setting the error code
            return {
                ...state,
                loading: false
            };
        case actions.EXPORT_LOAD_LIST_SUCCESS:
            return updateExports(state, action);
        case actions.SET_EXPORT_PAGE_PAGINATION:
            return updateExportPagePagination(state, action);
        case actions.EXPORT_DOWNLOAD_STARTED:
            return {
                ...state,
                dialogOpen: true,
                loading: true,
                status: action.type
            };
        case actions.EXPORT_DOWNLOAD_SUCCESS:
            return {
                ...state,
                exportData: action.exportData,
                status: action.type
            };
        case EXPORT_GENERATE_STARTED:
            return {
                ...state,
                dialogOpen: true,
                loading: true,
                status: action.type,
                exportData: null,
            };
        case EXPORT_GENERATE_SUCCESS:
            return {
                ...state,
                dialogOpen: false,
                loading: false,
                status: null
            };
        case EXPORT_GENERATE_ERROR:
            return {
                ...state,
                status: action.type,
                loading: false,
                err: action.err
            };
        case EXPORT_DIALOG_CLOSE:
            return {
                ...state,
                dialogOpen: false,
                loading: false,
                status: null,
                err: false,
            };
        default:
            return state;
    };
}

export default exportEntriesReducer;